var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('p',{staticClass:"news-title"},[_vm._v(_vm._s(_vm.info.title))]),_vm._v(" "),_c('p',{staticClass:"news-time"},[_vm._v("发布时间："+_vm._s(_vm.info.time))]),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.info.content)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e788b1b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Newscont.vue
// module id = null
// module chunks = 